export default __webpack_public_path__ + "static/media/icon-pinterest.61a35844.svg";